var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FadeTransition,[(_setup.isFetchingInitialData)?_c(_setup.LoaderIndicator,{staticClass:"margin-allocation__loader",attrs:{"with-container":""}}):_c(_setup.step.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }